import {
  StyleSheet,
  View,
  TouchableOpacity,
  Modal,
  Image,
} from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import React, { useState, memo } from "react";
import color from "@constants/color";
import Play from "@assets/svg/Play";
import CloseIcon from "@assets/svg/CloseIcon";
import VideoPlayer from "@components/VideoPlayer";
import { GetVideoTimeContextProvider } from "@utils/useGetVideoTime";
import analytics from "@services/analytics";
import { PERFORMANCE_MATRICES } from "@constants/analyticsEventsCT";

const VideoInfoModal = ({ videoInfo = {} }) => {
  const insets = useSafeAreaInsets();
  const [show, setShow] = useState(false);

  const playVideo = () => {
    analytics.trackEvent(PERFORMANCE_MATRICES.VIDEO_PLAYED);
    setShow(true);
  };

  const onPressCloseVideo = () => {
    setShow(false);
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        testID="play"
        onPress={playVideo}
        style={styles.videoStyle}
      >
        <Image
          source={{ uri: videoInfo.thumbnail }}
          style={{ height: 72, width: 72 }}
        />
        <View style={styles.playButton}>
          <Play width={7.2} height={11.04} color={color.white} />
        </View>
      </TouchableOpacity>

      <Modal
        onRequestClose={onPressCloseVideo}
        visible={show}
        transparent
        statusBarTranslucent
        navigationBarTranslucent
      >
        <View
          style={{
            ...StyleSheet.absoluteFill,
            backgroundColor: "#000000",
            justifyContent: "center",
            paddingTop: insets.top,
            paddingBottom: insets.bottom,
          }}
        >
          <TouchableOpacity
            onPress={onPressCloseVideo}
            testID="close"
            style={{
              position: "absolute",
              top: insets.top + 20,
              right: 23,
              zIndex: 5,
            }}
          >
            <CloseIcon fill={"#fff"} />
          </TouchableOpacity>
          <GetVideoTimeContextProvider>
            <VideoPlayer
              videoLink={videoInfo?.url}
              onEnd={() => {}}
              resumedEventTrack={() => {}}
              pausedEventTrack={() => {}}
            />
          </GetVideoTimeContextProvider>
        </View>
      </Modal>
    </View>
  );
};

export default memo(VideoInfoModal);

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 9,
    paddingHorizontal: 16,
  },
  videoStyle: {
    width: 72,
    height: 72,
    borderRadius: 4,
    backgroundColor: color.extraLightBlack,
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  video: {
    width: "100%",
    height: "100%",
  },
  playButton: {
    position: "absolute",
    zIndex: 100,
    justifyContent: "center",
    alignItems: "center",
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: color.mediumBlack,
    borderColor: color.white,
    borderWidth: 1,
  },
});
